import { ActionTree } from 'vuex'

import { RootState } from '@/store/types'

import { Mutations, UiState } from '@/store/ui/types'

const actions: ActionTree<UiState, RootState> = {
  setIsFunnelSaveStepOpen({ commit }, value: boolean) {
    commit(Mutations.SET_IS_FUNNEL_SAVE_STOP_OPEN, value)
  },
}

export default actions
